module.exports = __webpack_public_path__ + "static/media/intro_pic2.c16a8ec8.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/intro_pic2.png
 ** module id = 459
 ** module chunks = 0
 **/